import React, { useState, useEffect } from "react";
import meeting1 from "../../Image/Frame 24.png";
import Meeting2 from "../../Image/Frame26.png";
import "./Calender.css";
const apiUrl = process.env.REACT_APP_API_BASE_URL;

export default function Calendar() {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedDay, setSelectedDay] = useState(new Date().getDate());
    const [events, setEvents] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [newEventTitle, setNewEventTitle] = useState("");
    const [newEventTime, setNewEventTime] = useState("");

   
    useEffect(() => {
        fetch(`${apiUrl}/api/auth/allevents`)
            .then(response => response.json())
            .then(data => setEvents(data))
            .catch(error => console.error("Error fetching events:", error));
    }, []);

    const changeMonth = (offset) => {
        const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + offset, 1);
        setCurrentDate(newDate);
    };

    const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();

    // Function to add a new event using POST API
    const handleAddEvent = () => {
        if (newEventTitle.trim() === "" || newEventTime.trim() === "") {
            alert("Please enter both event title and time.");
            return;
        }

        const newEvent = {
            title: newEventTitle,
            date: `2025-03-${selectedDay}`,
            time: newEventTime,
            icon: meeting1
        };

        fetch(`${apiUrl}/api/auth/events`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newEvent)
        })
        .then(response => response.json())
        .then(data => {
            setEvents([...events, data]); // Add new event to list
            setNewEventTitle("");
            setNewEventTime("");
            setShowForm(false);
        })
        .catch(error => console.error("Error adding event:", error));
    };

    return (
        <div className="sideb">
            <div className="schedule-container">
                <h2 className="dashboard-h2">My Schedule</h2>
                <div className="calendar">
                    <div className="month-header">
                        <button onClick={() => changeMonth(-1)}>{"<"}</button>
                        <span>
                            {currentDate.toLocaleString("default", { month: "long" })} {currentDate.getFullYear()}
                        </span>
                        <button onClick={() => changeMonth(1)}>{">"}</button>
                    </div>
                    <div className="weekdays">
                        {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((day) => (
                            <span key={day}>{day}</span>
                        ))}
                    </div>
                    <div className="days">
                        {Array(firstDayOfMonth).fill(null).map((_, i) => <span key={`empty-${i}`} className="empty"></span>)}
                        {Array.from({ length: daysInMonth }, (_, i) => (
                            <span
                                key={i + 1}
                                className={selectedDay === i + 1 ? "selected" : ""}
                                onClick={() => setSelectedDay(i + 1)}
                            >
                                {i + 1}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="event-list">
                    <h3>
                        My Schedule <span className="add-event" onClick={() => setShowForm(true)}>+</span>
                    </h3>
                    {events
                        .filter(event => new Date(event.date).getMonth() === currentDate.getMonth())
                        .map(event => (
                            <div className="event-item" key={event._id}>
                                <img src={event.icon} alt="" className="event-icon" />
                                <div>
                                    <p>{event.title}</p>
                                    <p>{event.date === `2025-03-${selectedDay}` ? "Today" : event.date} {event.time}</p>
                                </div>
                            </div>
                        ))}
                </div>

                {showForm && (
                    <div className="event-form">
                        <h3>Add New Event</h3>
                        <input
                            type="text"
                            placeholder="Enter event title"
                            value={newEventTitle}
                            onChange={(e) => setNewEventTitle(e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Enter event time"
                            value={newEventTime}
                            onChange={(e) => setNewEventTime(e.target.value)}
                        />
                        <button onClick={handleAddEvent}>Add Event</button>
                        <button onClick={() => setShowForm(false)}>Cancel</button>
                    </div>
                )}
            </div>
        </div>
    );
}
